import { OrderStatus } from "@jti/magento";

/**
 * Order statuses that are considered valid for displaying the post-order survey.
 */
export const SURVEY_ELIGIBLE_ORDER_STATUSES = [
  OrderStatus.payment_completed,
  OrderStatus.pending_payment,
  OrderStatus.processing,
  OrderStatus.confirmed,
] as const;
